"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToResponses = void 0;
const json_1 = require("@stoplight/json");
const pickBy = require("lodash.pickby");
const context_1 = require("../../context");
const guards_1 = require("../../guards");
const resolver_1 = require("../../oas/resolver");
const examples_1 = require("../../oas/transformers/examples");
const schema_1 = require("../../oas/transformers/schema");
const utils_1 = require("../../utils");
const accessors_1 = require("../accessors");
const guards_2 = require("../guards");
const params_1 = require("./params");
const translateToResponse = (0, context_1.withContext)(function (produces, statusCode, response) {
    const resolvedResponse = this.maybeResolveLocalRef(response);
    if (!(0, guards_2.isResponseObject)(resolvedResponse))
        return;
    const actualKey = this.context === 'service' ? (0, resolver_1.getSharedKey)(resolvedResponse) : statusCode;
    const headers = params_1.translateToHeaderParams.call(this, resolvedResponse.headers);
    const objectifiedExamples = (0, utils_1.entries)(resolvedResponse.examples || (0, accessors_1.getExamplesFromSchema)(resolvedResponse.schema)).map(([key, value]) => examples_1.translateToDefaultExample.call(this, key, value));
    const contents = produces
        .map((0, context_1.withContext)(produceElement => ({
        id: this.generateId(`http_media-${this.parentId}-${produceElement}`),
        mediaType: produceElement,
        examples: objectifiedExamples.filter(example => example.key === produceElement),
        ...pickBy({
            schema: (0, json_1.isPlainObject)(resolvedResponse.schema)
                ? schema_1.translateSchemaObject.call(this, resolvedResponse.schema)
                : undefined,
        }, guards_1.isNonNullable),
    })), this)
        .filter(({ schema, examples }) => !!schema || examples.length > 0);
    const translatedResponses = {
        id: this.generateId(`http_response-${this.parentId}-${actualKey}`),
        code: statusCode,
        description: resolvedResponse.description,
        headers,
        contents,
    };
    const foreignExamples = objectifiedExamples.filter(example => !produces.includes(example.key));
    if (foreignExamples.length > 0) {
        if (translatedResponses.contents.length === 0)
            translatedResponses.contents[0] = {
                id: this.generateId(`http_media-${this.parentId}-`),
                mediaType: '',
                schema: {},
                examples: [],
            };
        translatedResponses.contents[0].examples.push(...foreignExamples);
    }
    return translatedResponses;
});
const translateToResponses = function (operation) {
    const produces = (0, accessors_1.getProduces)(this.document, operation);
    return (0, utils_1.entries)(operation.responses)
        .map(([statusCode, response]) => translateToResponse.call(this, produces, statusCode, response))
        .filter(guards_1.isNonNullable);
};
exports.translateToResponses = translateToResponses;
//# sourceMappingURL=responses.js.map